export const SESSION_KEY_HEADER = 'buildingbrief-session-key'
